import { defineComponent as u } from "vue";
import s from "./td-longtail-vue-components19.js";
import { useLabeledInput as f } from "./td-longtail-vue-components257.js";
const y = /* @__PURE__ */ u({
  __name: "checkbox-input",
  props: {
    label: { default: void 0 },
    labelClass: { default: void 0 },
    id: { default: void 0 },
    errorMessage: { default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    showLabel: { type: Boolean },
    large: { type: Boolean },
    hideAsterisk: { type: Boolean },
    idPrefix: { default: void 0 },
    placeholder: { default: void 0 },
    inputClass: { default: void 0 },
    maxlength: { default: void 0 },
    inputProps: { default: void 0 },
    value: { type: [Boolean, null], default: void 0 }
  },
  emits: ["input", "focus"],
  setup(n, { expose: p, emit: e }) {
    const o = n, { inputWrapperProps: d, inputFieldProps: r, focus: t, onInput: a } = f(o, e), l = (i) => {
      o.readonly || e("input", i.target?.checked);
    };
    return p({ focus: t, onChange: l, onInput: a }), { __sfc: !0, props: o, emits: e, inputWrapperProps: d, inputFieldProps: r, focus: t, onInput: a, onChange: l, InputWrapper: s };
  }
});
export {
  y as default
};
